"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _styles = require("../../styles");

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

require("../../chart-options/color-series-chart-options");

var _defaultShortNumberFormatter = _interopRequireDefault(require("../../label-formatters/default-short-number-formatter"));

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _selectedPoint = _interopRequireDefault(require("../../selected-point"));

var _tooltipFormatters = require("../../tooltip-formatters");

var _legendClickHandlers = require("../../legend-click-handlers");

var _axisLabelFormatters = require("../../label-formatters/axis-label-formatters");

var DEFAULT_LEGEND_CLICK_HANDLER = undefined;
var DEFAULT_TOOLTIP_FORMATTER = undefined;
var DEFAULT_X_AXIS_LABEL_STEP = null;
var DEFAULT_X_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.PASS_THROUGH;
var DEFAULT_X_AXIS_TICK_LENGTH = 4;
var DEFAULT_X_AXIS_TICK_WIDTH = 1;
var DEFAULT_Y_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.DEFAULT_NUMBER_LABEL;
var DEFAULT_Y_AXIS_TITLE_TEXT = undefined;
/**
 * @callback MwChartNSeriesLineLegendClickHandler
 *
 * Custom behavior to handle a click on a label in the legend.
 *
 * @param {MwChartNSeriesLineLegendClickOptions} options Options provided by the chart
 * @returns {undefined}
 */

/**
 * @callback MwChartNSeriesLineOnPointClick
 *
 * @param {NSeriesPointClickOptions} - Passed NSeriesPointClickOptions
 * @returns {function}
 */

/**
 * @callback MwChartNSeriesAxisLabelFormatter
 *
 * Custom behavior to format the label for a particular mark on the x-axis.
 *
 * @param {AxisLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the x-axis label
 */

/**
 * @callback MwChartNSeriesLineTooltipFormatter
 *
 * Custom behavior to transform point information into an HTML tooltip.
 *
 * @param {MwChartNSeriesLineTooltipOptions} options Options provided by the chart
 * @returns {string} HTML to show in the tooltip
 */

/**
 * A class to represent the visualization options for a N Series Line Chart
 *
 * @implements {ColorSeriesChartOptions}
 *
 * @param {object} options options object (See below)
 * @param {boolean} [options.animate=true] Dictate whether to animate the chart when rendering (True=yes, false=no)
 * @param {boolean} [options.areDataLabelsVisible=false] Dictate whether to show labels on the points of the chart (True=yes, false=no)
 * @param {function} [options.dataLabelFormatter] A function to be passed a value to format data label
 * @param {number[]} [options.hiddenSeriesIndices=[]] Each entry is the index of a series that should be "hidden". "hidden" means the line will not be visible, but it will still be present in the legend
 * @param {boolean} [options.hideLegend=false] Dictate whether to hide legend on the chart
 * @param {function} [options.onError] A function to handle an error when rendering
 * @param {MwChartNSeriesLineLegendClickHandler|LegendClickHandlers} [options.onLegendClick] A function to handle a legend click or a predefined LegendClickHandlers
 * @param {MwChartNSeriesLineOnPointClick} [options.onPointClick] A function to be passed a point data object (ie key, keyIndex, seriesName, value) on click
 * @param {String[]} [options.seriesColors] An array of colors for Series lines
 * @param {SelectedPoint[]} [options.selectedPoints=[]] An array of pre selected points
 * @param {MwChartNSeriesLineTooltipFormatter|TooltipFormatters} [options.tooltipFormatter] Custom handler to format tooltips
 * @param {MwChartNSeriesAxisLabelFormatter} [options.xAxisLabelFormatter] Custom handler to format x-axis labels
 * @param {number} [options.xAxisLabelStep] Indicates how often to display a label on the x-axis. (Eg 1 will display all labels. 2 will every other. 3 every third.)
 * @param {number} [options.xAxisTickLength=4] The length of the tick mark to be displayed on the x-axis (in px)
 * @param {number} [options.xAxisTickWidth=1] The width of the tick mark to be displayed on the x-axis (in px)
 * @param {MwChartNSeriesAxisLabelFormatter|AxisLabelFormatter} [options.yAxisLabelFormatter=AxisLabelFormatters.DEFAULT_NUMBER_LABEL] A function to format y-axis labels, or a named AxisLabelFormatter. If provided a function, the function is provided AxisLabelFormatterOptions.
 * @param {string} [options.yAxisTitleText] The Y Axis title text (Eg #ffbbcc)
 */

var MwChartNSeriesLineOptions =
/* eslint-disable-next-line complexity */
function MwChartNSeriesLineOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartNSeriesLineOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.animate === undefined) {
    safeOptions.animate = true;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.animate, 'options.animate');
  }

  if (safeOptions.areDataLabelsVisible === undefined) {
    safeOptions.areDataLabelsVisible = false;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.areDataLabelsVisible, 'options.areDataLabelsVisible');
  }

  if (safeOptions.dataLabelFormatter === undefined) {
    safeOptions.dataLabelFormatter = _defaultShortNumberFormatter.default;
  } else {
    _argumentContracts.default.assertFunction(safeOptions.dataLabelFormatter, 'options.dataLabelFormatter');
  }

  var safeHiddenIndices = safeOptions.hiddenSeriesIndices;

  if (safeOptions.hiddenSeriesIndices === undefined) {
    safeHiddenIndices = [];
  } else {
    _argumentContracts.default.assertArrayOf(safeOptions.hiddenSeriesIndices, Number, 'safeOptions.hiddenSeriesIndices');
  }

  if (typeof safeOptions.onError !== 'function' && safeOptions.onError !== undefined) {
    throw new TypeError("options.onError must be a function. Provided value: ".concat(safeOptions.onError));
  }

  if (safeOptions.hideLegend === undefined) {
    safeOptions.hideLegend = false;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.hideLegend, 'options.hideLegend');
  }

  var safeOnLegendClick;

  if (safeOptions.onLegendClick === undefined) {
    safeOnLegendClick = DEFAULT_LEGEND_CLICK_HANDLER;
  } else if ((0, _legendClickHandlers.isValidLegendClickHandler)(safeOptions.onLegendClick)) {
    safeOnLegendClick = safeOptions.onLegendClick;
  } else {
    _argumentContracts.default.assertFunction(safeOptions.onLegendClick, 'safeOptions.onLegendClick');

    safeOnLegendClick = safeOptions.onLegendClick;
  }

  if (typeof safeOptions.onPointClick !== 'function' && safeOptions.onPointClick !== undefined) {
    throw new TypeError("options.onPointClick must be a function. Provided value: ".concat(safeOptions.onPointClick));
  }

  if (safeOptions.seriesColors === undefined) {
    safeOptions.seriesColors = _styles.DEFAULT_SERIES_CHART_COLORS;
  } else if (!Array.isArray(safeOptions.seriesColors) || !safeOptions.seriesColors.every(function (color) {
    return (0, _isHexColorValue.default)(color);
  })) {
    throw new TypeError("options.seriesColors must be an array of hex colors. Provided value: ".concat(JSON.stringify(safeOptions.seriesColors)));
  }

  if (safeOptions.tooltipFormatter === undefined) {
    safeOptions.tooltipFormatter = DEFAULT_TOOLTIP_FORMATTER;
  } else if (typeof safeOptions.tooltipFormatter === 'string') {
    if (!(0, _tooltipFormatters.isValidTooltipFormatter)(safeOptions.tooltipFormatter)) {
      throw new TypeError("options.tooltipFormatter must be a recognized TooltipFormatter if a string is provided. Provided value: ".concat(safeOptions.tooltipFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.tooltipFormatter, 'options.tooltipFormatter');
  }

  if (safeOptions.xAxisLabelFormatter === undefined) {
    safeOptions.xAxisLabelFormatter = DEFAULT_X_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.xAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.xAxisLabelFormatter)) {
      throw new TypeError("options.xAxisLabelFormatter must be a known AxisLabelFormatter. Provided: ".concat(safeOptions.xAxisLabelFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.xAxisLabelFormatter, 'options.xAxisLabelFormatter');
  }

  if (safeOptions.xAxisLabelStep === undefined || safeOptions.xAxisLabelStep === null) {
    safeOptions.xAxisLabelStep = DEFAULT_X_AXIS_LABEL_STEP;
  } else if (typeof safeOptions.xAxisLabelStep !== 'number') {
    _argumentContracts.default.assertNumber(options.xAxisLabelStep, 'options.xAxisLabelStep');
  }

  if (safeOptions.xAxisTickLength === undefined) {
    safeOptions.xAxisTickLength = DEFAULT_X_AXIS_TICK_LENGTH;
  } else {
    _argumentContracts.default.assertNumber(options.xAxisTickLength, 'options.xAxisTickLength');
  }

  if (safeOptions.xAxisTickWidth === undefined) {
    safeOptions.xAxisTickWidth = DEFAULT_X_AXIS_TICK_WIDTH;
  } else {
    _argumentContracts.default.assertNumber(options.xAxisTickWidth, 'options.xAxisTickWidth');
  }

  if (safeOptions.yAxisLabelFormatter === undefined) {
    safeOptions.yAxisLabelFormatter = DEFAULT_Y_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.yAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.yAxisLabelFormatter)) {
      throw new TypeError("options.yAxisLabelFormatter must be a known AxisLabelFormatter if provided as a string. Provided: ".concat(JSON.stringify(safeOptions.yAxisLabelFormatter)));
    }
  } else {
    _argumentContracts.default.assertFunction(options.yAxisLabelFormatter, 'options.yAxisLabelFormatter');
  }

  if (safeOptions.yAxisTitleText === undefined) {
    safeOptions.yAxisTitleText = DEFAULT_Y_AXIS_TITLE_TEXT;
  } else {
    _argumentContracts.default.assertString(options.yAxisTitleText, 'options.yAxisTitleText');
  }

  var safeSelectedPoints = [];
  var safeSelectedPointsMap = {};

  if (safeOptions.selectedPoints !== undefined) {
    if (!Array.isArray(safeOptions.selectedPoints)) {
      throw new TypeError("selectedPoints must be an array. Provided value: ".concat(JSON.stringify(safeOptions.selectedPoints)));
    }

    safeSelectedPoints = safeOptions.selectedPoints.map(function (selectedPoint) {
      return (0, _coerce.default)(selectedPoint, _selectedPoint.default, "Every entry in selectedPoints must be a valid SelectedPoint. Provided value: ".concat(JSON.stringify(selectedPoint)));
    });
    safeSelectedPointsMap = {};
    safeSelectedPoints.forEach(function (selectedPoint) {
      safeSelectedPointsMap[selectedPoint.serialize()] = selectedPoint;
    });
  }

  this.animate = safeOptions.animate;
  this.areDataLabelsVisible = safeOptions.areDataLabelsVisible;
  this.dataLabelFormatter = safeOptions.dataLabelFormatter;
  this.hiddenSeriesIndices = safeHiddenIndices;
  this.hideLegend = safeOptions.hideLegend;
  this.onError = safeOptions.onError;
  this.onLegendClick = safeOnLegendClick;
  this.onPointClick = safeOptions.onPointClick;
  this.selectedPoints = safeSelectedPoints;
  this.selectedPointsMap = safeSelectedPointsMap;
  this.seriesColors = safeOptions.seriesColors;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  this.xAxisLabelFormatter = safeOptions.xAxisLabelFormatter;
  this.xAxisLabelStep = safeOptions.xAxisLabelStep;
  this.xAxisTickLength = safeOptions.xAxisTickLength;
  this.xAxisTickWidth = safeOptions.xAxisTickWidth;
  this.yAxisLabelFormatter = safeOptions.yAxisLabelFormatter;
  this.yAxisTitleText = safeOptions.yAxisTitleText;
  Object.freeze(this);
};

exports.default = MwChartNSeriesLineOptions;